module.exports = require("./dist/storyteller.min.js").Storyteller;